"use strict";

module.exports = function (val) {
  return val.toUpperCase();
};